import { request } from '@@/plugin-request';

export async function queryOperationsByMatchmaker(params) {
  return request('/api/matchmakersManageOperations/getOperationsByMatchmaker', {
    method: 'get',
    params,
  });
}

export async function updateMatchmakerOperations(payload) {
  return request('/api/matchmakersManageOperations', {
    method: 'put',
    data: payload,
  });
}

export async function getMatchmakerOfOperation(params) {
  return request('/api/matchmakersManageOperations/getMatchmakerOfOperation', {
    method: 'get',
    params,
  });
}
